<template>
    <div id="rechargeDetail">
        <div>
            <div class="line">
                <label>订单号：</label>
                <div><span>{{ package.orderNo }}</span></div>                
            </div>
            
            <div class="line">
                <label>套餐名称：</label>
                <div><span>{{ package.packageName }}</span></div>                
            </div>
            <div class="line">
                <label>套餐类型：</label>
                <div><span>{{ package.investTypeName }}</span></div>                
            </div>
            <div class="line">                
                <label>支付方式：</label>
                <div><span>{{ package.payTypeName }}</span></div>                
            </div>
            <div class="line">
                <label>充值时间：</label>
                <div><span>{{ package.createTime }}</span></div>                
            </div>
            <div class="line">
                <label>金额：</label>
                <div><span>{{ package.priceRmb }} 元</span></div>                
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    name: 'rechargeDetail',
    data(){
        return {
            package: ''
        }
    },
    created(){
        this.package = this.$route.query;
    }
}
</script>
<style lang="less">
#rechargeDetail {
    padding: 10px 3%;
}
</style>
